import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';

export type ScoreCardsState = {
  validatedAnalysisTypeIds: number[];
  filterId: null | number;
  filterAnalysesResources: {
    selectedSegmentId?: number;
    selectedAlertTypeId?: number;
    selectedScorecardId?: number;
  };
  analyzerStatus: {
    analyzer_started_at: string | null;
    analyzer_completed_at: string | null;
    analyzer_status: string | null;
  };
};

const initialState = {
  validatedAnalysisTypeIds: [],
  filterId: null,
  filterAnalysesResources: {
    selectedSegmentId: undefined,
    selectedAlertTypeId: undefined,
    selectedScorecardId: undefined,
  },
  analyzerStatus: {
    analyzer_started_at: null,
    analyzer_completed_at: null,
    analyzer_status: null,
  },
};

const reducer: Reducer<ScoreCardsState, FluxStandardAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_VALIDATED_ANALYSIS_TYPES_FULFILLED':
      return {
        ...state,
        validatedAnalysisTypeIds: action.payload.data.analysis_types,
        filterId: action.payload.data.filter_id,
      };
    case 'CREATE_ANALYSIS_TYPE_FOR_BRAND_PENDING': {
      return {
        ...state,
        validatedAnalysisTypeIds: [
          ...state.validatedAnalysisTypeIds,
          ...action.meta.analysisTypeIds,
        ],
        filterId: action.meta.filterId,
      };
    }
    case 'CREATE_ANALYSIS_TYPE_FOR_BRAND_REJECTED': {
      return {
        ...state,
        validatedAnalysisTypeIds: state.validatedAnalysisTypeIds.filter(
          typeId => !action.meta.analysisTypeIds.includes(typeId)
        ),
        filterId: state.filterId,
      };
    }
    case 'UPDATE_SELECTED_SEGMENT_ID': {
      return {
        ...state,
        filterAnalysesResources: {
          ...state.filterAnalysesResources,
          selectedSegmentId:
            state.filterAnalysesResources.selectedSegmentId === action.payload
              ? null
              : action.payload,
        },
      };
    }
    case 'UPDATE_SELECTED_ALERT_TYPE_ID': {
      return {
        ...state,
        filterAnalysesResources: {
          ...state.filterAnalysesResources,
          selectedAlertTypeId:
            state.filterAnalysesResources.selectedAlertTypeId === action.payload
              ? null
              : action.payload,
        },
      };
    }
    case 'UPDATE_SELECTED_SCORECARD_ID': {
      return {
        ...state,
        filterAnalysesResources: {
          ...state.filterAnalysesResources,
          selectedScorecardId:
            state.filterAnalysesResources.selectedScorecardId === action.payload
              ? null
              : action.payload,
        },
      };
    }
    case 'DELETE_ANALYSIS_TYPE_FOR_BRAND_PENDING': {
      return {
        ...state,
        validatedAnalysisTypeIds: state.validatedAnalysisTypeIds.filter(
          typeId => !action.meta.analysisTypeIds.includes(typeId)
        ),
      };
    }
    case 'DELETE_ANALYSIS_TYPE_FOR_BRAND_REJECTED': {
      return {
        ...state,
        validatedAnalysisTypeIds: [
          ...state.validatedAnalysisTypeIds,
          ...action.meta.analysisTypeIds,
        ],
      };
    }
    case 'FETCH_BRAND_OVERLAPS_ANALYZER_STATUS_FULFILLED': {
      return {
        ...state,
        analyzerStatus: {
          analyzer_started_at: action.payload?.data?.analyzer_started_at || null,
          analyzer_completed_at: action.payload?.data?.analyzer_completed_at || null,
          analyzer_status: action.payload?.data?.status || null,
        },
      };
    }
  }
  return state;
};

export default reducer;
